import { render } from "./mobile-nav-stats.vue?vue&type=template&id=c71b441c"
import script from "./mobile-nav-stats.vue?vue&type=script&lang=js"
export * from "./mobile-nav-stats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__